import React from 'react'

import PrivacyPolicyContent from 'components/PrivacyPolicy'
import useI18n from 'hooks/useI18n'
import Wrapper from '../Wrapper'
import { ModalContainer, TermTitle } from './styled'

export default function ModalTerm() {
  const { t } = useI18n()

  return (
    <Wrapper title={t('term_title')} modalWidth="1080px">
      <ModalContainer>
        <TermTitle>Privacy statement</TermTitle>
        <PrivacyPolicyContent />
      </ModalContainer>
    </Wrapper>
  )
}
